import { ChevronLeftIcon, CloseIcon } from "@chakra-ui/icons";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { FolderIcon } from "@root/assets/icons/foldericon";
import { useEffect, useState } from "react";
import { useProjectsContext } from "@root/context/projects-context";
import { PAGINATION_DEFAULTS, VIEW_TYPE } from "@root/constants";
import NextIcon from "@root/assets/icons/next-icon.svg";
import { getFileIcon } from "@root/constants/checklist";
import { useTranslation } from "react-i18next";
import { Loader } from "../loader";
import { Paginate } from "../pagination";

const ProjectsListing = () => {
  const { toggleRightSidebar, openProjectsListing } = useMainChatContext();
  const {
    fetchProjects,
    foldersData,
    folderData,
    projectsData,
    projectData,
    documentsData,
    handleFolderClick,
    handleProjectClick,
    view,
    handleBackClick,
    getProjectsLoading,
    getFoldersLoading,
    getDocumentsLoading,
    fetchFolders,
    fetchDocuments,
    page,
    setView,
    setPage,
    folderCount,
    documentCount,
  } = useProjectsContext();
  console.log("view:: ", view);
  const { selectedProject, setSelectedProject } = useMainChatContext();
  const { docChatMode } = useMainChatContext();
  const { t } = useTranslation("common");
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(
    null
  );
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);

  const payload = {
    offset: (page - 1) * PAGINATION_DEFAULTS.PAGESIZE,
    page,
  };

  // useEffect(() => {
  //   setView(VIEW_TYPE.PROJECT);
  // }, [selectedProject]);

  if (!openProjectsListing) {
    return null;
  }

  const onProjectClick = (project: any) => {
    setSelectedProjectId(project?.id); // save for later pagination
    handleProjectClick(project); // call the original handler from props
  };

  const onFolderClick = (folder: any) => {
    setSelectedFolderId(folder?.id); // save for later pagination
    handleFolderClick(folder); // call the original handler from props
  };

  const handlePageChange = (newPage: number, view: string, id: any) => {
    setPage(newPage);
    const payload = {
      limit: PAGINATION_DEFAULTS.PAGESIZE,
      page: newPage,
    };
    if (view === VIEW_TYPE.PROJECT) {
      fetchProjects(payload);
    } else if (view === VIEW_TYPE.FOLDER) {
      fetchFolders({ projectId: id, ...payload });
    } else if (view === VIEW_TYPE.DOCUMENT) {
      fetchDocuments({ folderId: id, ...payload });
    }
  };

  const renderNoDataFound = (text: string) => (
    <Text
      mt={"4px"}
      noOfLines={2}
      fontSize={"14px"}
      color={"#6D6D70"}
      textAlign={"center"}
      marginTop={"120px"}
    >
      {text}
    </Text>
  );

  const renderContent = () => {
    if (view === VIEW_TYPE.PROJECT) {
      return (
        <Box height="100%" display="flex" flexDirection="column">
          {/* Header */}
          <Flex justifyContent="space-between" alignItems="center">
            <Text fontWeight={700} fontSize="16px" color="#1A1A1A">
              {t("projects.projectsFolder")}
            </Text>
            <Flex
              gap="10px"
              alignItems="center"
              onClick={toggleRightSidebar}
              cursor="pointer"
            >
              {/* <Text fontWeight={500} fontSize="14px" color="#798692">
                {t("projects.close")}
              </Text> */}
              <CloseIcon boxSize={3} color="#798692" />
            </Flex>
          </Flex>

          {/* Scrollable Content */}
          <Box flex="1" overflowY="auto" mt="20px">
            <Text fontWeight={500} color="#757575" mb="20px" fontSize={"14px"}>
              {t("projects.projects")}
            </Text>

            <Flex flexDir="column">
              {projectsData?.rows
                ?.filter((project: any) => project?.id !== 3)
                ?.map((project: any, index: number, filteredArray: any[]) => (
                  <Box key={project?.id}>
                    <Flex
                      py="12px"
                      gap="15px"
                      cursor="pointer"
                      onClick={() => onProjectClick(project)}
                      alignItems={"center"}
                    >
                      <FolderIcon size={30} color="#1A1A1A" />
                      <Text
                        noOfLines={1}
                        fontWeight={500}
                        fontSize={"16px"}
                        color="#0E0E0E"
                      >
                        {project?.name}
                      </Text>
                    </Flex>
                    {index < filteredArray.length - 1 && (
                      <Box borderBottom="1px solid #EBEBEB" />
                    )}
                  </Box>
                ))}
              {getProjectsLoading && <Loader />}
              {!projectsData?.rows?.length &&
                renderNoDataFound("No projects found")}
            </Flex>
          </Box>

          {/* Pagination - Sticks to bottom */}
          <Flex
            justifyContent="center"
            py="10px"
            borderTop="1px solid #E0E0E0"
            ml="100px"
          >
            <Paginate
              page={page}
              count={projectsData?.count}
              pageSize={PAGINATION_DEFAULTS.PAGESIZE}
              onPageChange={(newPage) =>
                handlePageChange(newPage, view, selectedProjectId)
              }
            />
          </Flex>
        </Box>
      );
    }

    if (view === VIEW_TYPE.FOLDER) {
      return (
        <Box height={"100%"} display={"flex"} flexDir={"column"}>
          <Box>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              mb={"15px"}
            >
              {/* Back button - only show if not in project mode */}
              {!selectedProject ? (
                <Flex
                  gap={"3px"}
                  alignItems={"center"}
                  cursor={"pointer"}
                  onClick={handleBackClick}
                >
                  <ChevronLeftIcon color={"#798692"} />
                  <Text fontSize={"14px"} fontWeight={500} color={"#798692"}>
                    {t("projects.back")}
                  </Text>
                </Flex>
              ) : (
                <Box /> // Empty box to maintain space-between layout
              )}
              {/* Close button */}
              <Flex
                gap={"10px"}
                alignItems={"center"}
                onClick={toggleRightSidebar}
                cursor={"pointer"}
              >
                <Text fontWeight={500} fontSize={"14px"} color={"#798692"}>
                  {t("projects.close")}
                </Text>
                <CloseIcon boxSize={3} color={"#798692"} />
              </Flex>
            </Flex>
            {/* Title below */}
            <Text fontWeight={600} fontSize={"20px"} color={"#2F2F34"}>
              {projectData?.name}
            </Text>
            <Text
              fontWeight={500}
              color="#757575"
              mb="10px"
              fontSize={"14px"}
              mt={"15px"}
            >
              {t("projects.folders")}
            </Text>
            <Box>
              <Flex flexDir={"column"}>
                {foldersData?.rows?.map((folder: any, index: number) => (
                  <Box key={folder?.id}>
                    <Flex
                      py={"12px"}
                      gap={"15px"}
                      cursor={"pointer"}
                      onClick={() => onFolderClick(folder)}
                      alignItems={"center"}
                    >
                      <FolderIcon size={30} color="#6648FF" />
                      <Text
                        noOfLines={1}
                        fontWeight={500}
                        fontSize={"16px"}
                        color={"#0E0E0E"}
                      >
                        {folder?.name}
                      </Text>
                    </Flex>
                    {index < foldersData?.rows?.length - 1 && (
                      <Box borderBottom="1px solid #EBEBEB" />
                    )}
                  </Box>
                ))}
                {getFoldersLoading && <Loader />}
                {!foldersData?.rows?.length &&
                  renderNoDataFound("No folders found")}
              </Flex>
            </Box>
          </Box>

          <Flex mt="auto" pt="10px" ml="100px">
            <Paginate
              page={page}
              count={folderCount}
              pageSize={PAGINATION_DEFAULTS.PAGESIZE}
              onPageChange={(newPage) =>
                handlePageChange(newPage, view, selectedProjectId)
              }
            />
          </Flex>
        </Box>
      );
    }
    if (view === VIEW_TYPE.DOCUMENT) {
      return (
        <Box height={"100%"} display={"flex"} flexDir={"column"}>
          <Box>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              mb={"15px"}
            >
              {/* Back button */}
              <Flex
                gap={"3px"}
                alignItems={"center"}
                onClick={handleBackClick}
                cursor={"pointer"}
              >
                <ChevronLeftIcon color={"#798692"} />
                <Text fontSize={"14px"} fontWeight={500} color={"#798692"}>
                  {t("projects.back")}
                </Text>
              </Flex>
              {/* Close button */}
              <Flex
                gap={"10px"}
                alignItems={"center"}
                onClick={toggleRightSidebar}
                cursor={"pointer"}
              >
                <Text fontWeight={500} fontSize={"14px"} color={"#798692"}>
                  {t("projects.close")}
                </Text>
                <CloseIcon boxSize={3} color={"#798692"} />
              </Flex>
            </Flex>
            {/* Title below */}
            {/* <Text fontWeight={600} fontSize={"20px"} color={"#2F2F34"}>
              {projectData?.name}
            </Text> */}
            <Flex gap={"10px"} mt={"5px"}>
              <Image src={NextIcon} />
              <Text fontSize={"18px"} fontWeight={500} color={"#6D6D70"}>
                {folderData?.name}
              </Text>
            </Flex>
            <Flex mt={"25px"} justifyContent={"space-between"}>
              <Text fontWeight={600} color={"#231F20"}>
                {t("projects.files")}
              </Text>
              <Text
                borderRadius={"50px"}
                bgColor={"#EAF5FA"}
                border={"1px solid #40599B"}
                fontSize={"12px"}
                color={"#40599B"}
                p={"2px 6px"}
              >
                {t("projects.filesCount", {
                  count: foldersData?.rows[0]?.documents?.length,
                })}
              </Text>
            </Flex>
          </Box>
          <Box mt={"15px"} flex={1} overflowY={"scroll"}>
            <Flex flexDir={"column"} gap={"15px"}>
              {foldersData?.rows[0]?.documents?.map((document: any) => (
                <Flex
                  key={document?.id}
                  border={"1px solid #A7A9AB80"}
                  borderRadius={"8px"}
                  px={"10px"}
                  py={"6px"}
                  gap={"10px"}
                  cursor={"pointer"}
                  bgColor={"#8D919E26"}
                >
                  <Image src={getFileIcon(document?.extension)} boxSize={7} />
                  <Box>
                    <Text noOfLines={1}>{document?.fileName_key}</Text>
                  </Box>
                </Flex>
              ))}
              {getDocumentsLoading && <Loader />}
              {!foldersData?.rows[0]?.documents?.length &&
                renderNoDataFound("No documents found")}
            </Flex>
          </Box>
          <Flex mt="auto" pt="10px" ml="100px">
            <Paginate
              page={page}
              count={documentCount}
              pageSize={PAGINATION_DEFAULTS.PAGESIZE}
              onPageChange={(newPage) =>
                handlePageChange(newPage, view, selectedFolderId)
              }
            />
          </Flex>
        </Box>
      );
    }
  };

  return (
    <Box py={"15px"} px={"15px"} height={"100%"}>
      {renderContent()}
    </Box>
  );
};

export default ProjectsListing;
